module.exports = __webpack_public_path__ + "static/media/before.70d501b5.png";